// src/pages/LoginPage.jsx
import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Auth.css"; // 로그인/회원가입 공통 스타일

function LoginPage() {
  const navigate = useNavigate();
  const { user, login } = useAuth(); // AuthContext에서 user, login 가져오기

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // 이미 로그인된 상태면 비밀번호 변경 필요 여부 확인 후 리다이렉트
  useEffect(() => {
    if (!user) return;

    const isRecoveryMode =
      window.sessionStorage.getItem("password_recovery_mode") === "1";
    if (isRecoveryMode) {
      navigate("/forgot-password?type=recovery", { replace: true });
      return;
    }

    // 비밀번호를 변경하지 않은 경우 비밀번호 변경 페이지로 리다이렉트
    if (user.password_changed === false) {
      navigate("/change-password", { replace: true });
      return;
    }

    // 비밀번호를 변경한 경우 role에 따라 리다이렉트
    if (user.role === "admin") {
      navigate("/admin", { replace: true });
    } else {
      navigate("/main", { replace: true });
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      await login(email, password);
      // navigate는 useEffect가 user.role 보고 결정
    } catch (err) {
      console.error("Login error:", err);
      // 더 명확한 오류 메시지 표시
      if (err.message) {
        setError(err.message);
      } else if (err.originalError?.message) {
        setError(err.originalError.message);
      } else {
        setError("이메일 또는 비밀번호를 확인해 주세요.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        {/* 왼쪽 브랜드 / 인삿말 영역 */}
        <div className="auth-left">
          <h1 className="portal-title">업무 활동 조사</h1>
          <p className="portal-desc">
            개인의 업무 활동 내용과 소요 시간 조사를 위한 서비스 입니다
          </p>
        </div>

        {/* 오른쪽 로그인 폼 */}
        <div className="auth-right">
          <h2 className="auth-section-title">로그인</h2>
          <p className="auth-section-desc">
            사내 계정으로 로그인하여 HR Analytics 기능을 이용하세요.
          </p>

          <form className="auth-form" onSubmit={handleSubmit}>
            <label className="auth-label">
              이메일
              <input
                type="email"
                className="auth-input"
                placeholder="name@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </label>

            <label className="auth-label">
              비밀번호
              <input
                type="password"
                className="auth-input"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </label>

            {error && <div className="auth-error">{error}</div>}

            <button
              type="submit"
              className="auth-submit-btn"
              disabled={isLoading}
            >
              {isLoading ? "로그인 중..." : "로그인"}
            </button>
          </form>

          <div className="auth-footer">
            비밀번호를 잊으셨나요?{" "}
            <Link to="/forgot-password" className="auth-link">
              비밀번호 찾기
            </Link>
            {" · "}
            <Link to="/signup" className="auth-link">
              아직 계정이 없으신가요? 회원가입
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;